namespace TabAurous.Inventory {
    export namespace LotCreationItemsService {
        export const baseUrl = 'Inventory/LotCreationItems';

        export declare function Create(request: Serenity.SaveRequest<LotCreationItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<LotCreationItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LotCreationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LotCreationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetSKUDetails(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<LotCreationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/LotCreationItems/Create",
            Update = "Inventory/LotCreationItems/Update",
            Delete = "Inventory/LotCreationItems/Delete",
            Retrieve = "Inventory/LotCreationItems/Retrieve",
            List = "Inventory/LotCreationItems/List",
            GetSKUDetails = "Inventory/LotCreationItems/GetSKUDetails"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetSKUDetails'
        ].forEach(x => {
            (<any>LotCreationItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
